import { render, staticRenderFns } from "./ItemTableHeader.vue?vue&type=template&id=2f8c3318"
import script from "./ItemTableHeader.vue?vue&type=script&lang=ts"
export * from "./ItemTableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports